import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api } from "@/lib/api";
import { MenuRenderer } from "@/components/app/MenuRenderer";

export default function DesignPreview() {
  const { id } = useParams();
  const [config, setConfig] = useState(null);

  useEffect(() => {
    const load = () => api.get(`/designs/${id}`).then((r) => setConfig(r.data.config)).catch(() => {});
    load();
    const itv = setInterval(load, 5000);
    return () => clearInterval(itv);
  }, [id]);

  if (!config) {
    return <div className="tv-screen flex items-center justify-center text-gray-500 text-sm">Loading preview…</div>;
  }
  return (
    <div className="tv-screen" data-testid="preview-screen">
      <MenuRenderer config={config} scale="tv" />
    </div>
  );
}
